import { useContext } from "react";

import { LazyContextType, LazyStateContext } from "./context";

export function usePickingSessionRef(): LazyContextType {
    const context = useContext(LazyStateContext);

    if (context === undefined) {
        throw new Error("usePickingSessionRef must be used within a PickingSessionProvider");
    }

    return context;
}
